const initAccordion = () => {
    const accordionBtns = document.querySelectorAll(".faq-tab__title");

    accordionBtns.forEach((accordion) => {
        accordion.addEventListener('click', () => {
            if(accordion.classList.contains('active')) {
                accordion.classList.remove('active');
                accordion.nextElementSibling.classList.remove('active');
            }
            else {
                accordion.classList.add('active');
                accordion.nextElementSibling.classList.add('active');
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initAccordion();
});